import dayjs from 'dayjs';

export const formatReadableDate = (isoDate?: string | null): string => {
  if (!isoDate) return '-';
  const date = dayjs(isoDate);
  if (!date.isValid()) return '-';
  return date.format('DD MMM YYYY, hh:mm A'); // e.g. "06 Nov 2025, 02:04 PM"
};